/* The Lab NA — design-system runtime helpers for production Shopify.
   Replaces design-canvas features used in .dc.html references:
   - [style-hover] / [style-active] attribute styling
   - [data-lab-hide-md] responsive hiding
   - [data-lab-open-quote] triggers and the global lab:open-quote event
*/
(function () {
  'use strict';

  /* ---------- style-hover / style-active ---------- */
  function applyStyleOverride(el, key, attr) {
    if (el['_lab_' + key]) return;
    var base = el.getAttribute('style') || '';
    var override = el.getAttribute(attr) || '';
    el['_lab_base_' + key] = base;
    el.setAttribute('style', (base ? base + '; ' : '') + override);
    el['_lab_' + key] = true;
  }

  function removeStyleOverride(el, key) {
    if (!el['_lab_' + key]) return;
    el.setAttribute('style', el['_lab_base_' + key] || '');
    el['_lab_' + key] = false;
  }

  document.addEventListener('mouseover', function (e) {
    var el = e.target.closest('[style-hover]');
    if (el) applyStyleOverride(el, 'hover', 'style-hover');
  });

  document.addEventListener('mouseout', function (e) {
    var el = e.target.closest('[style-hover]');
    if (el) removeStyleOverride(el, 'hover');
  });

  document.addEventListener('mousedown', function (e) {
    var el = e.target.closest('[style-active]');
    if (el) applyStyleOverride(el, 'active', 'style-active');
  });

  document.addEventListener('mouseup', function (e) {
    var el = e.target.closest('[style-active]');
    if (el) removeStyleOverride(el, 'active');
  });

  /* ---------- quote CTA event wiring ---------- */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-lab-open-quote]');
    if (trigger) {
      e.preventDefault();
      window.dispatchEvent(new CustomEvent('lab:open-quote', { bubbles: true }));
    }
  });

  window.addEventListener('lab:open-quote', function () {
    var consult = document.getElementById('consult');
    if (consult) {
      var y = consult.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({ top: y, behavior: 'smooth' });
      return;
    }
    if (window.CTAPanel && window.CTAPanel.open) {
      window.CTAPanel.open();
      if (window.CallTrk && window.CallTrk.swap) {
        window.CallTrk.swap();
      }
    }
  });

  /* ---------- CallRail DNI helper ---------- */
  function labCallRailSwap(root) {
    if (window.CallTrk && window.CallTrk.swap) {
      window.CallTrk.swap(root || document.body);
    }
  }
  window.labCallRailSwap = labCallRailSwap;

  /* ---------- hero video source swap + reduced motion ---------- */
  function initHeroVideos() {
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var mobile = window.matchMedia && window.matchMedia('(max-width: 767px)').matches;

    document.querySelectorAll('video[data-hero-video]').forEach(function (video) {
      var src = mobile ? video.getAttribute('data-src-mobile') : video.getAttribute('data-src-desktop');
      var poster = video.getAttribute('data-poster') || video.getAttribute('poster') || '';
      var fallback = video.parentElement && video.parentElement.querySelector('.lab-hero__poster');

      if (mobile && !src && (poster || fallback)) {
        video.removeAttribute('autoplay');
        video.pause();
        if (fallback) {
          video.style.display = 'none';
          fallback.removeAttribute('hidden');
          fallback.style.display = 'block';
        } else {
          video.setAttribute('poster', poster);
          video.setAttribute('preload', 'none');
        }
        return;
      }
      if (mobile && !src) src = video.getAttribute('data-src-desktop');

      if (reduced) {
        video.removeAttribute('autoplay');
        video.pause();
        video.style.display = 'none';
        if (fallback) { fallback.removeAttribute('hidden'); fallback.style.display = 'block'; }
        return;
      }

      if (!src) return;
      video.setAttribute('src', src);
      if (poster) video.setAttribute('poster', poster);
      video.load();
      var playAttempted = false;
      var tryPlay = function () {
        if (playAttempted) return;
        playAttempted = true;
        video.play().catch(function () {});
      };
      if (video.readyState >= 3) {
        tryPlay();
      } else {
        video.addEventListener('canplay', tryPlay, { once: true });
      }
    });

    if (reduced) {
      document.querySelectorAll('video-media[autoplay]').forEach(function (el) { el.paused = true; });
    }
  }

  /* ---------- header navigation (dropdowns + mobile accordion) ---------- */
  function initLabHeader(header) {
    if (!header) return;

    var menu = header.querySelector('.lab-header__mobile-menu');
    var hamburger = header.querySelector('.lab-header__hamburger');

    if (hamburger && menu) {
      hamburger.addEventListener('click', function () {
        var open = menu.classList.toggle('is-open');
        hamburger.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    header.querySelectorAll('.lab-header__mobile-toggle, .lab-header__dropdown-toggle').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        var panel = btn.nextElementSibling;
        if (panel) {
          if (panel.classList.contains('lab-services-accordion')) {
            panel.classList.toggle('is-open', !expanded);
            var inner = panel.querySelector('.lab-header__dropdown-list--mobile');
            if (inner) inner.classList.toggle('is-open', !expanded);
          } else {
            panel.classList.toggle('is-open', !expanded);
          }
        }
      });
    });

    header.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        header.querySelectorAll('[aria-expanded="true"]').forEach(function (el) { el.setAttribute('aria-expanded', 'false'); });
        header.querySelectorAll('.is-open').forEach(function (el) { el.classList.remove('is-open'); });
        if (menu) menu.classList.remove('is-open');
        if (hamburger) hamburger.setAttribute('aria-expanded', 'false');
      }
    });

    document.addEventListener('click', function (e) {
      if (!header.contains(e.target)) {
        if (menu) menu.classList.remove('is-open');
        if (hamburger) hamburger.setAttribute('aria-expanded', 'false');
        header.querySelectorAll('.lab-header__mobile-toggle[aria-expanded="true"], .lab-header__dropdown-toggle[aria-expanded="true"]').forEach(function (btn) {
          btn.setAttribute('aria-expanded', 'false');
          var panel = btn.nextElementSibling;
          if (panel) panel.classList.remove('is-open');
        });
      }
    });
  }

  function labInitAll() {
    labCallRailSwap();
    initHeroVideos();
    document.querySelectorAll('.lab-header').forEach(initLabHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', labInitAll);
  } else {
    labInitAll();
  }
})();
